<template>
  <section class="pt-8 mx-auto w-10/12">
    <div id="step1" class="row grid-margin">
      <div class="col-xs-6">
        <div v-for="(templateDetails, index) in evenIndexTemplates" :key="index">
          <table class="table rounded-lg bg-white w-full mb-6 shadow">
            <thead class="head">
              <tr>
                <th class="text-xl text-pdsPrimaryColor text-left px-4 py-2">
                  {{ templateDetails.TreatmentAreaDescription }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(template, index) in templateDetails.Templates" :key="index">
                <td
                  @click="goToCreateAccountability(template.TemplateId)"
                  class="cursor py-2 px-4 text-gray-500"
                  :class="{ 'pb-4': index + 1 === templateDetails.Templates.length }"
                >
                  {{ template.Naam }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-xs-6">
        <div v-for="(templateDetails, index) in oddIndexTemplates" :key="index">
          <table class="table rounded-lg bg-white w-full mb-6 shadow">
            <colgroup>
              <col v-for="n in 1" :key="n" :class="'table-col-' + n++" />
            </colgroup>
            <thead class="head">
              <tr>
                <th class="text-xl text-pdsPrimaryColor text-left px-4 py-2">
                  {{ templateDetails.TreatmentAreaDescription }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(template, index) in templateDetails.Templates" :key="index">
                <td
                  @click="goToCreateAccountability(template.TemplateId)"
                  class="cursor py-2 px-4 text-gray-500"
                  :class="{ 'pb-4': index + 1 === templateDetails.Templates.length }"
                >
                  {{ template.Naam }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--Pop up to show stop license -->
    <generic-modal v-if="showPopUp">
      <template #header>
        {{ popUpText.header }}
      </template>
      <template #body>
        <p>{{ popUpText.text }}</p>
      </template>
      <template #footer>
        <v-button tagelement="button" hollow md transparent class="cancelPopUp" @click="backToDashboard()">
          Annuleren
        </v-button>
        <v-button tagelement="button" md primary @click="closeLicense()"> Doorgaan </v-button>
      </template>
    </generic-modal>
  </section>
</template>
<script>
import router from '@/router';
import GenericModal from '@/components/shared/GenericModal';
import { navigateToAccountability } from '@/services';

import { useStore } from 'vuex';
import { computed, onMounted, onUnmounted } from 'vue';

export default {
  name: 'VNewauthorization',
  components: { GenericModal },
  setup() {
    const store = useStore();

    const treatmentWiseTemplates = computed(
      () => store.getters['accountability/getTreatmentAreaWiseAccountabilityTemplates']
    );
    const evenIndexTemplates = computed(() => treatmentWiseTemplates.value.filter((_, index) => index % 2 === 0));
    const oddIndexTemplates = computed(() => treatmentWiseTemplates.value.filter((_, index) => index % 2 !== 0));

    const showPopUp = computed(() => store.getters['accountability/getLicenseStopPopUpStatus']);
    const popUpText = computed(() => store.getters['login/getCloseLicensePopUpDetails']);

    const resetTreatmentAreaWiseTemplates = (value) =>
      store.commit('accountability/resetTreatmentAreaWiseTemplates', value);
    const setAccountabilities = (value) => store.commit('accountability/setAccountabilities', value);
    const setShowExtendLicensesBlock = (value) => store.commit('accountability/setShowExtendLicensesBlock', value);
    const startNewAccountability = (value) => store.dispatch('accountability/startNewAccountability', value);
    const setLicenseStopPopUpStatus = (value) => store.commit('accountability/setLicenseStopPopUpStatus', value);

    const fetchAccountabilities = async () => await store.dispatch('accountability/fetchAccountabilities');

    onMounted(async () => {
      await fetchAccountabilities();
    });

    onUnmounted(() => {
      resetTreatmentAreaWiseTemplates();
      setAccountabilities([]);
    });
    const goToCreateAccountability = (id) => {
      setShowExtendLicensesBlock(false);
      startNewAccountability(id).then((response) => {
        navigateToAccountability(response.regular.accountabilityId);
      });
    };

    const backToDashboard = () => {
      router.push('/patientdashboard');
      setLicenseStopPopUpStatus(false);
    };

    const closeLicense = () => {
      setLicenseStopPopUpStatus(false);
    };

    return {
      treatmentWiseTemplates,
      evenIndexTemplates,
      oddIndexTemplates,
      showPopUp,
      popUpText,
      resetTreatmentAreaWiseTemplates,
      setAccountabilities,
      setShowExtendLicensesBlock,
      startNewAccountability,
      setLicenseStopPopUpStatus,
      fetchAccountabilities,
      goToCreateAccountability,
      backToDashboard,
      closeLicense
    };
  }
};
</script>
